import type { BreadcrumbProps as AntBreadcrumbProps } from "antd";
import { Breadcrumb as AntBreadcrumb } from "antd";
import React from "react";
export type BreadcrumbItem = {
  /** The display text of the breadcrumb item */
  title: string;
  /** The target link of the breadcrumb item (optional) */
  href?: string;
};
export type BreadcrumbProps = AntBreadcrumbProps & {
  /** Array of breadcrumb items */
  items: BreadcrumbItem[];
};
const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, ...props }) => {
  return (
    <AntBreadcrumb {...props}>
      {items.map((item, index) => (
        <AntBreadcrumb.Item key={index} href={item.href}>
          {item.title}
        </AntBreadcrumb.Item>
      ))}
    </AntBreadcrumb>
  );
};
export default Breadcrumb;
